<template>
  <form role="form" @submit="onFormSubmit" name="shop-content-switch-form">
    
    <Select
      v-if="listShopContents.length > 0"
      :label="$t('cms.site.switch.label')"
      :placeholder="$t('cms.site.switch.select_placeholder')"
      :selectOptions="{
        options: listShopContents,
        getOptionLabel : option => option.shop.name
      }"
      v-bind:value.sync="form.shopContent" 
      :labelAsColumn="false"
    />
    
    <button class="btn btn-primary ladda-button" data-style="zoom-in" type="submit">{{ $t('cms.site.switch.button') }}</button>
  </form>
</template>

<style>
  form[name=shop-content-switch-form] {
    display: flex;
  }

  form[name=shop-content-switch-form] > div {
    display: flex;
    margin-bottom: 0;
    flex-grow:1;
  }

  form[name=shop-content-switch-form] > div > label {
    margin-right:10px;
    line-height: 36px;
    margin-bottom: 0px;
  }

  form[name=shop-content-switch-form] > div > div {
    flex-grow:1;
  }

  form[name=shop-content-switch-form] > button {
    margin-left:10px;
  }
</style>

<script lang="ts"> 
import { Ref, defineComponent, PropType, computed, onMounted, onBeforeUnmount, ref, watch, reactive } from '@fwk-node-modules/vue'
import { getApp, useRouter, useStore } from '@fwk-client/utils/vue-3-migration';

import Select from '@fwk-client/components/panels/input/Select.vue';
import * as Ladda from 'ladda';
import { languagesTypes } from '@fwk-client/store/types';

import { useVigneronOnlineAdmin } from '../../composables/useVigneronOnlineAdmin';

export default defineComponent({
    props: {
        
    },
    components: {
      Select
    },
    setup(props, context) {
      const app = getApp();
      const $router = useRouter();
      const $store = useStore();

      const { shopContents, selectedShopContent, selectShopContent } = useVigneronOnlineAdmin(props, context);

      const form:any = reactive({
        shopContent: selectedShopContent.value ? selectedShopContent.value.shopContent : undefined
      })
    
      var laddaSubmit:Ladda.LaddaButton|null = null;

      onMounted(() => {
        var button:HTMLButtonElement|null = document.querySelector( 'form[name=shop-content-switch-form] button' );
        laddaSubmit = Ladda.create(button!);
      })

      const onFormSubmit = (evt:Event) => {
        // We prevent submit of the page
        evt.preventDefault();

        laddaSubmit!.start();
        selectShopContent(form.shopContent._id).then(() => {
          laddaSubmit!.stop();
        });
      }

      const listShopContents = computed(() => {
        return shopContents.value.map((shopContent:any) => {
          return shopContent.shopContent;
        })
      })

      return { 
        listShopContents,
        form,
        selectedShopContent,
        onFormSubmit
      }
    }
})
</script>